import { Product } from './models/product';

export const INTERVAL = 10; // minutes
export const CURRENCY = 'or';

export const PRODUCTS: Product[] = [
  {
    name: 'Katana éternel',
    image: 'katana.png',
    crashPrice: 1,
    minPrice: 3,
    maxPrice: 7,
  },
  {
    name: 'Lotus blanc',
    image: 'lotus.png',
    crashPrice: 2,
    minPrice: 4,
    maxPrice: 11,
  },
  {
    name: 'bombe noir',
    image: 'bombe.png',
    crashPrice: 2,
    minPrice: 3,
    maxPrice: 8,
  },
  {
    name: 'Crâne maudit',
    image: 'crane.png',
    crashPrice: 1,
    minPrice: 2,
    maxPrice: 9,
  },
  {
    name: 'Terre sauvage',
    image: 'sauvage.png',
    crashPrice: 3,
    minPrice: 4,
    maxPrice: 10,
  },
  {
    name: 'Tipi tonnerre',
    image: 'tipi.png',
    crashPrice: 1,
    minPrice: 5,
    maxPrice: 15,
  },
  {
    name: 'Cactus sauvage',
    image: 'cactus.png',
    crashPrice: 1,
    minPrice: 3,
    maxPrice: 8,
  },
  {
    name: 'Shérif de l’ouest',
    image: 'sherif.png',
    crashPrice: 2,
    minPrice: 4,
    maxPrice: 12,
  },
];
